import {
  ExclamationCircleFilled,
  UploadOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Card } from 'antd'
import React from 'react'

import type { UploadStatusNormalized } from './utils/uploadStatus'

interface UploadStatusCardsProps {
  statusResponse: UploadStatusNormalized
  statusView: string
}

export function UploadStatusCards({
  statusResponse,
  statusView,
}: UploadStatusCardsProps) {
  const totalSuccess =
    (statusResponse.updated_count || 0) + (statusResponse.created_count || 0)

  return (
    <Horizontal gap={16} className='flex justify-sb mb-3'>
      <StatusCard
        count={totalSuccess}
        status='success'
        label='Record(s) Uploaded'
        icon={
          <Texto
            appearance={totalSuccess === 0 ? 'hint' : 'success'}
            category='h3'
          >
            <UploadOutlined />
          </Texto>
        }
      />
      <StatusCard
        count={statusResponse.warning_count}
        status='warning'
        label='Record Warning(s)'
        icon={
          <Texto
            appearance={statusResponse.warning_count === 0 ? 'hint' : 'warning'}
            category='h3'
          >
            <WarningOutlined />
          </Texto>
        }
        statusView={statusView}
      />
      <StatusCard
        count={statusResponse.error_count}
        status='error'
        label='Record Error(s)'
        icon={
          <Texto
            appearance={statusResponse.error_count === 0 ? 'hint' : 'error'}
            category='h3'
          >
            <ExclamationCircleFilled />
          </Texto>
        }
        statusView={statusView}
      />
    </Horizontal>
  )
}

interface StatusCardProps {
  count: number
  status: string
  label: string
  icon: React.ReactNode
  statusView?: string
}

function StatusCard({
  count,
  status,
  label,
  icon,
  statusView: _statusView,
}: StatusCardProps) {
  const disabled = count < 1
  const borderColor =
    status === 'success'
      ? 'var(--theme-success)'
      : status === 'warning'
        ? 'var(--theme-warning)'
        : 'var(--theme-error)'

  return (
    <Card
      size='small'
      style={{
        flex: 1,
        ...(count > 0 && { border: `1px solid ${borderColor}` }),
        textAlign: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <div>{icon}</div>
        <Texto
          category='h2'
          weight='bold'
          appearance={disabled ? 'hint' : undefined}
        >
          {count || 0}
        </Texto>
        <Texto weight='semibold' appearance={disabled ? 'hint' : undefined}>
          {label}
        </Texto>
      </div>
    </Card>
  )
}
